module.exports = __webpack_public_path__ + "img/nmg.a9cc45a3.png";